import { PREVIEW_RARITIES } from '@game-platform/pack-animation';

interface Props {
  /** A badge name, or '' for a different rarity on every cycle. */
  value: string;
  onChange: (value: string) => void;
}

// Matches the theme editor's top-bar controls (h-7, px-3, font-mono 11px).
/** Which rarity the preview pretends to pull — drives the glow / badge tint. */
export function RaritySelector({ value, onChange }: Props) {
  return (
    <select
      aria-label="Preview rarity"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="h-7 rounded border border-neutral-700 bg-neutral-900 px-3 font-mono text-[11px] text-white outline-none hover:bg-neutral-800"
    >
      <option value="">Random rarity</option>
      {PREVIEW_RARITIES.map((rarity) => (
        <option key={rarity} value={rarity}>
          {rarity}
        </option>
      ))}
    </select>
  );
}
